<template>
    
</template>

<script>
    export default {
        name: "FirstFinancingList"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FirstFinancingList.vue